module.exports = __webpack_public_path__ + "static/media/SVG_menu_like.797e349a.svg";